import {
    UserInfo,
    ConversationRequest,
    Conversation,
    ChatMessage,
    CosmosDBHealth,
    CosmosDBStatus,
    Message,
    ChatResponseChoice,
    SingleConversation
} from "./models";
import { chatHistorySampleData } from "../constants/chatHistory";
import { AppStateContext } from "../state/AppProvider";
import { jwtDecode } from "jwt-decode";
import { get } from "lodash";
import axios from "axios";
import { useContext, useEffect } from "react";
import { BackendURL } from "../../env";
import { normalizeVoiceAppKey } from "../utils/voiceApp";
export async function conversationApi(
    aiService: string,
    subaiService: string,
    options: ConversationRequest,
    abortSignal: AbortSignal
): Promise<Response> {
    const Email = localStorage.getItem("Email");
    const Entraid = localStorage.getItem("Entraid")
    const response = await fetch(`${BackendURL}/conversation`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            ai_service: aiService,
            subai_service: subaiService,
            messages: options.messages,
            email: Email,
            userId: Entraid,
            tenantId: localStorage.getItem("TenantId")
        }),
        signal: abortSignal,
    });

    return response;
}
export async function getUserInfo(): Promise<UserInfo[]> {
    const response = await fetch("/.auth/me");
    if (!response.ok) {
        // console.log("No identity provider found. Access to chat will be blocked.");
        return [];
    }

    const payload = await response.json();
    return payload;
}
import { useNavigate, Navigate, Link } from "react-router-dom";

// export const fetchChatHistoryInit = async (): Promise<Conversation[] | null> => {
export const fetchChatHistoryInit = (): Conversation[] | null => {
    // Make initial API call here

    // return null;
    return chatHistorySampleData;
};

// export const getText = async (content_Id: any, content:any, flag :boolean) => {
//     try {
//         // Fetch data from the API
//         const response = fetch(`/text_to_speechStart?conversationid=${encodeURIComponent(content_Id)}&content=${encodeURIComponent(content)}&flag=${encodeURIComponent(flag)}`, {
//             method: "GET",

//         });
//         // Check if the response is successful (status code 200-299)
//         // Now you can use the 'data' object as needed
//     } catch (error) {
//         console.error('Error fetching data:', error);
//     }

// };

// export const StopText = ( flag :any) => {
//     try {
//         // Fetch data from the API
//         const response = fetch(`/text_to_speechStop?flag=${encodeURIComponent(flag)}`, {
//             method: "GET",

//         });
//         // Check if the response is successful (status code 200-299)
//         // Now you can use the 'data' object as needed
//     } catch (error) {
//         console.error('Error fetching data:', error);
//     }

// };

export const Get_Feedback = async (
    content_id: any,
    options: any,
    message: any
): Promise<Response> => {
    const Entraid = localStorage.getItem("Entraid");
    const Email = localStorage.getItem("Email");
    const response = await fetch(`${BackendURL}/feedback`, {
        method: "POST",
        body: JSON.stringify({
            content_id: content_id,
            option: options,
            message: message,
            userId: Entraid,
            Email: Email
        }),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then(async (res) => {
            // Log the content of the request body to the console
            // console.log("Request body:", JSON.stringify({
            //     conversation_id: convId,
            //     messages: messages
            // }));
            return res;
        })
        .catch((err) => {
            console.error("There was an issue fetching your data.");
            let errRes: Response = {
                ...new Response(),
                ok: false,
                status: 500,
            };
            return errRes;
        });
    return response;
};

// Your function to send data to Flask API
// export const getText = async () => {
//     try {
//         // Your data
//         const dataToSend = {
//             content_Id: 'content_Id',
//             content: 'content',
//             flag: 'flag'
//         };

//         // Make a POST request to the Flask API endpoint
//         const response = await axios.post('/text_to_speech', dataToSend);

//         // Handle response if needed
//         console.log('Response:', response.data);
//     } catch (error) {
//         console.error('Error:', error);
//     }
// };

export const historyList = async (selectedAI: string | null) => {
    const Entraid = localStorage.getItem("Entraid");

    if (!Entraid) {
        throw new Error("Missing Entraid in localStorage");
    }

    try {
        // const requestPayload =
        //     selectedAI === "MultiModel"
        //         ? {
        //               Entraid,
        //               is_multi_model: true,
        //               ai_service: "" 
        //           }
        //         : {
        //               Entraid,
        //               is_multi_model: false,
        //               ai_service: selectedAI || ""
        //           };

        const response = await fetch(`${BackendURL}/history/list`, {
            method: "POST",
            body: JSON.stringify({ Entraid: Entraid }),

            headers: { "Content-Type": "application/json" },
        });

        const payload = await response.json();


        if (!Array.isArray(payload)) {
            console.error("Invalid response format from the server.");
            return null;
        }

        const conversations: Conversation[] = payload.map((conv: any) => ({
            id: conv.id,
            title: conv.title,
            date: conv.createdAt,
            messages: [],
            ml_service: conv.ml_service
        }));

        return conversations;
    } catch (err) {
        console.error("Error fetching history list:", err);
        return null;
    }
};



export const historyRead = async (convId: string) => {
    if (!convId) return [];

    try {
        const Entraid = localStorage.getItem("Entraid");
        const res = await fetch(`${BackendURL}/history/read`, {
            method: "POST",
            body: JSON.stringify({
                conversation_id: convId,
                userId: Entraid
            }),
            headers: { "Content-Type": "application/json" },
        });

        const payload = await res.json();



        if (!payload?.messages) return [];


        // const singleConversation :SingleConversation = payload?.messages;


        const singleConversation: ChatMessage[] = payload.messages;
        return singleConversation;

        // const conversations: Conversation[] = singleConversation.map((conv: any) => ({
        //         id: conv.id,
        //         title: conv.title,
        //         date: conv.createdAt,
        //         messages: payload?.messages ,
        //     }));
        //     return conversations;

        // return payload.messages.map((msg: any) => ({
        //   id: msg.id,
        //   role: msg.role,
        //   date: msg.createdAt,
        //   content: msg.content,
        // }));
    } catch (error) {
        console.error("Error reading conversation:", error);
        return [];
    }
};



export const historyGenerate = async (
    aiService: string,
    subaiService: string,
    message_id: string,
    options: ConversationRequest,
    abortSignal: AbortSignal,
    convId?: string,
    liveSearch?: boolean
): Promise<Response> => {
    const Email = localStorage.getItem("Email");
    const Entraid = localStorage.getItem("Entraid")
    console.log("convId", convId)
    let body;
    if (convId) {
        body = JSON.stringify({
            ai_service: aiService,
            subai_service: subaiService,
            conversation_id: convId,
            messages: options.messages,
            message_id: message_id,
            Email: Email,
            userId: Entraid
        });
    } else {
        body = JSON.stringify({
            ai_service: aiService,
            subai_service: subaiService,
            messages: options.messages,
            message_id: message_id,
            Email: Email,
            userId: Entraid
        });
    }

    const response = await fetch(`${BackendURL}/api/tools/conversation`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: body,
        signal: abortSignal,
    })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            console.error("There was an issue fetching your data.");
            return new Response();
        });
    return response;
};

export const historyUpdate = async (
    messages: ChatMessage[],
    convId: string
): Promise<Response> => {
    const Email = localStorage.getItem("Email");
    const Entraid = localStorage.getItem("Entraid")
    const response = await fetch(`${BackendURL}/history/update`, {
        method: "POST",
        body: JSON.stringify({
            conversation_id: convId,
            messages: messages,
            Email: Email,
            userId: Entraid
        }),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then(async (res) => {
            // Log the content of the request body to the console
            // console.log("Request body:", JSON.stringify({
            //     conversation_id: convId,
            //     messages: messages
            // }));
            return res;
        })
        .catch((err) => {
            console.error("There was an issue fetching your data.");
            let errRes: Response = {
                ...new Response(),
                ok: false,
                status: 500,
            };
            return errRes;
        });
    return response;
};

export const historyDelete = async (convId: string): Promise<Response> => {
    const Entraid = localStorage.getItem("Entraid")
    const response = await fetch(`${BackendURL}/history/delete`, {
        method: "DELETE",
        body: JSON.stringify({
            conversation_id: convId,
            Entraid: Entraid
        }),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            console.error("There was an issue fetching your data.");
            let errRes: Response = {
                ...new Response(),
                ok: false,
                status: 500,
            };
            return errRes;
        });
    return response;
};

export const historyDeleteAll = async (): Promise<Response> => {
    const Entraid = localStorage.getItem("Entraid")
    const response = await fetch(`${BackendURL}/history/delete_all`, {
        method: "DELETE",
        body: JSON.stringify({ Entraid: Entraid }),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            console.error("There was an issue fetching your data.");
            let errRes: Response = {
                ...new Response(),
                ok: false,
                status: 500,
            };
            return errRes;
        });
    return response;
};

export const historyClear = async (convId: string): Promise<Response> => {
    const Entraid = localStorage.getItem("Entraid")
    const response = await fetch(`${BackendURL}/history/clear`, {
        method: "POST",
        body: JSON.stringify({
            conversation_id: convId,
            userId: Entraid
        }),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            console.error("There was an issue fetching your data.");
            let errRes: Response = {
                ...new Response(),
                ok: false,
                status: 500,
            };
            return errRes;
        });
    return response;
};

export const historyRename = async (
    convId: string,
    title: string
): Promise<Response> => {
    const Entraid = localStorage.getItem("Entraid")
    const response = await fetch(`${BackendURL}/history/rename`, {
        method: "POST",
        body: JSON.stringify({
            conversation_id: convId,
            title: title,
            Entraid: Entraid
        }),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            console.error("There was an issue fetching your data.");
            let errRes: Response = {
                ...new Response(),
                ok: false,
                status: 500,
            };
            return errRes;
        });
    return response;
};

export const getblob = async (fname: string, conatinerName: string) => {
    try {
        // Fetch data from the API
        const response = await fetch(`${BackendURL}/blob/sas`, {
            method: "POST",
            body: JSON.stringify({
                FileName: fname,
                ConatinerName: conatinerName,
            }),
            headers: {
                "Content-Type": "application/json",
            },
        });

        // Check if the response is successful (status code 200-299)
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // Parse the JSON data
        const data = await response.json();

        // Handle the API response data
        return data;

        // Now you can use the 'data' object as needed
    } catch (error) {
        console.error("Error fetching data:", error);
    }
};

// export const getBlobSas = async (fname: string): Promise<Response> => {
//     const response = await fetch("/blob/sas", {
//         method: "POST",
//         body: JSON.stringify({
//             FileName: fname,

//         }),
//         headers: {
//             "Content-Type": "application/json"
//         },
//     })
//     .then((res) => {
//         console.log('Abhishek',res)
//         return res
//     })
//     .catch((err) => {
//         console.error("There was an issue fetching your sas url.");
//         let errRes: Response = {
//             ...new Response,
//             ok: false,
//             status: 500,
//         }
//         return errRes;
//     })
//     return response;
// }

export const historyEnsure = async (): Promise<CosmosDBHealth> => {
    const response = await fetch(`${BackendURL}/history/ensure`, {
        method: "GET",
    })
        .then(async (res) => {
            let respJson = await res.json();
            let formattedResponse;
            if (respJson.message) {
                formattedResponse = CosmosDBStatus.Working;
            } else {
                if (res.status === 500) {
                    formattedResponse = CosmosDBStatus.NotWorking;
                } else {
                    formattedResponse = CosmosDBStatus.NotConfigured;
                }
            }
            if (!res.ok) {
                return {
                    cosmosDB: false,
                    status: formattedResponse,
                };
            } else {
                return {
                    cosmosDB: true,
                    status: formattedResponse,
                };
            }
        })
        .catch((err) => {
            console.error("There was an issue fetching your data.");
            return {
                cosmosDB: false,
                status: err,
            };
        });
    return response;
};

export const fetchMonthlyBillingDetail = async () => {

    try {
        const Email = localStorage.getItem("Email");

        if (!Email) {
            throw new Error("Email not found");
        }

        const apiUrl: string = `${BackendURL}/get_monthly_billing`;

        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                Email: Email,
            }),
        });


        if (!response.ok) {
            throw new Error("Failed to fetch Montly billing detail");
        }

        const responseBody = await response.text();
        if (!responseBody) {
            throw new Error("Empty response body");
        }

        const data = JSON.parse(responseBody);


        return data;
    } catch (error) {
        console.error("Error fetching Mothly billing detail:", error);

        return [];
    }
};

export const fetchDailyBillingDetail = async () => {
    try {
        const Email = localStorage.getItem("Email");

        if (!Email) {
            throw new Error("Email not found");
        }

        const apiUrl: string = `${BackendURL}/get_daily_billing`;

        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                Email: Email,
            }),
        });

        if (!response.ok) {
            throw new Error("Failed to fetch Daily billing detail");
        }

        const responseBody = await response.text();
        if (!responseBody) {
            throw new Error("Empty response body");
        }

        const data = JSON.parse(responseBody);


        return data;
    } catch (error) {
        console.error("Error fetching Daily billing detail:", error);

        return [];
    }
};

//Fetch Model Details
export const fetchModelDetails = async (emailOverride?: string, isPrysmOverride?: boolean) => {
    const Email = emailOverride || localStorage.getItem("Email");
    const prysmView =
        typeof isPrysmOverride === "boolean"
            ? isPrysmOverride
            : ["1", "true"].includes(localStorage.getItem("PrysmView") || "");

    if (!Email) {
        throw new Error("Missing Email in localStorage");
    }

    const response = await fetch(`${BackendURL}/get_model_details`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ Email: Email, is_prysm: prysmView }),
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch model details. Status: ${response.status}`);
    }

    const data = await response.json();
    data.map((e: any) => {

        localStorage.setItem("Expertise", e.Expertise)
        localStorage.setItem("tenantId", e.tenant_id)



    })

    const sortedModels = data.sort(
        (a: any, b: any) => a.Display_Seq - b.Display_Seq
    );

    return sortedModels;
};


export const handleUsecases = async () => {
    // debugger
    try {
        const response = await fetch(`${BackendURL}/Usecases_list`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching use cases:", error);
        return [];
    }
};


export const CategoryUseCases = async () => {
    try {
        const usecaselist = await fetch(`${BackendURL}/Category_Usecases_list`, {
            method: "GET",
        })

        if (!usecaselist.ok) {
            throw new Error(`HTTP error! Status: ${usecaselist.status}`);
        }
        const data = await usecaselist.json()
        return data


    } catch (error) {
        console.error("Error fetching Category  Use Cases:", error);
        return [];
    }

}


export const UserSessionData = async () => {
    try {
        const response = await fetch(`${BackendURL}/session-user`, {
            method: "GET"
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();


        // If redirect is needed
        if (data.status === "Success" && data.auth_url) {
            window.location.href = data.auth_url;
            return;
        }


        return data;

    } catch (error) {
        console.error("Error fetching session data:", error);
        return null;
    }
};

export const fetchUserImage = async () => {
    try {
        const response = await fetch(`${BackendURL}/profile-photo`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json(); // Expecting { image: "data:image/jpeg;base64,..." }
        if (data.image) {
            localStorage.setItem("profileImage", data.image); // Store base64 string
            return data.image;
        } else {
            throw new Error("No image data received");
        }
    } catch (error) {
        console.error("Error fetching profile photo:", error);
    }
};


//  const requestPayload =
//             model === "MultiModel"
//                 ? {
//                       Entraid,
//                       is_multi_model: true,
//                       ai_service: ["abc", "def", "ghi"] // hardcoded 3 model names
//                   }
//                 : {
//                       Entraid,
//                       is_multi_model: false,
//                       ai_service: model || ""
//                   };

export const getSession = async (selectedApp?: string | null) => {
    try {
        const voiceApp = normalizeVoiceAppKey(selectedApp);
        const endpoint =
            voiceApp === "supportpop"
                ? `${BackendURL}/session_supportPop`
                : voiceApp === "jarvisone"
                    ? `${BackendURL}/session_JarvisOne`
                    : voiceApp === "lipione"
                        ? `${BackendURL}/session_LipiOne`
                        : `${BackendURL}/session`;

        const response = await fetch(
            endpoint,
            {
                method: "GET",
            }
        );

        if (!response.ok) {
            const errorBody = await response.json().catch(() => ({}));
            const message =
                errorBody?.error ||
                errorBody?.details?.error?.message ||
                `HTTP error! Status: ${response.status}`;
            throw new Error(`Realtime session request failed: ${message}`);
        }

        const data = await response.json();
        return data;

    } catch (error) {
        console.error("Error fetching realtime session:", error);
        throw error;
    }
};

export const callTool = async (name: string, args: any, selectedApp?: string | null) => {
    try {
        const voiceApp = normalizeVoiceAppKey(selectedApp);
        const endpoint =
            voiceApp === "supportpop"
                ? `${BackendURL}/tool_supportPop`
                : voiceApp === "jarvisone"
                    ? `${BackendURL}/tool_JarvisOne`
                    : voiceApp === "lipione"
                        ? `${BackendURL}/tool_LipiOne`
                        : `${BackendURL}/tool`;

        const response = await fetch(endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                name,
                arguments: args,
            }),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data;

    } catch (error) {
        console.error("Error calling MCP tool:", error);
        throw error;
    }
};


export const UserAccessManagement = async () => {
    try {
        const response = await fetch(`${BackendURL}/user_model_mapping`, {
            method: "GET"
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log(data);
        return data;
    } catch (error) {
        console.error("Error fetching user access data:", error);
        return null;
    }
};

export const fetchExpertiseDropdownOptions = async (): Promise<string[]> => {
    try {
        const response = await fetch(`${BackendURL}/Category_Dropdown_list`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        if (!Array.isArray(data)) return [];

        return data
            .map((item: any) => item?.Expertise)
            .filter((expertise: any): expertise is string =>
                typeof expertise === "string" && expertise.trim() !== ""
            );
    } catch (error) {
        console.error("Error fetching expertise options:", error);
        return [];
    }
};

// export type ManageUserModelMappingPayload = {
//     Action: "DELETE_USER" | "INSERT_USER" | "UPDATE_MODEL" | string;
//     Email: string;
//     FirstName?: string;
//     LastName?: string;
//     Expertise?: string;
//     IsActive?: number | boolean;
//     ModelData?: Array<{
//         ModelId: number | string;
//         VoiceEnabled: number | boolean;
//         IsModelEnable: number | boolean;
//     }>;
// };

export type ManageUserModelMappingPayload = {
    Action: "DELETE_USER" | "INSERT_USER" | "UPDATE_MODEL" | string;
    Email: string;
    FirstName?: string;
    LastName?: string;
    IsActive: number;
    Expertise?: string;
    // UpdatedEmail?: string;
    ModelId?: number | string | null;
    VoiceEnabled?: number | boolean | null;
    ModelData?: Array<{
        ModelId: number | string;
        VoiceEnabled: number | boolean;
        ModelEnable: number | boolean;

    }>;
};


export const ManageUserModelMapping = async (
    payload: ManageUserModelMappingPayload
) => {
    const response = await fetch(`${BackendURL}/manage-user-model-mapping`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
        throw new Error(data?.error || data?.message || `HTTP error! Status: ${response.status}`);
    }

    return data;
};

export interface LogoUploadResponse {
    message: string;
    image_blob_url: string;
    file_name: string;
}

export interface AvailableLogo {
    blob_url: string;
    file_name: string;
    is_active: boolean;
    uploaded_on: string;
}

export const uploadLogo = async (
    filelogo: string | Blob,
    Email: string | Blob,
    IsAdmin: string | Blob = "1",
    tenantId: string | Blob = localStorage.getItem("TenantId") || "1"
): Promise<LogoUploadResponse> => {
    try {
        const formdata = new FormData();
        formdata.append("tenant_id", tenantId)
        formdata.append("file", filelogo)
        formdata.append("Email", Email)
        formdata.append("isAdmin", IsAdmin)
        formdata.append("requestType", "logo")

        const res = await fetch(`${BackendURL}/upload_logo`, {
            method: "POST",
            body: formdata

        })

        if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
        }

        const data = await res.json();
        console.log(data);
        return data;

    } catch (error) {
        console.error("Error uploading logo:", error);
        throw error;
    }
}

export const getAvailableLogo = async (
    Email: string,
    tenantId: string = localStorage.getItem("TenantId") || "1"
): Promise<AvailableLogo[]> => {
    try {
        const res = await fetch(`${BackendURL}/get_available_logo`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                Email,
                tenant_id: tenantId,
            }),
        });

        if (res.status === 404) {
            return [];
        }

        if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
        }

        const data = await res.json();
        return Array.isArray(data) ? data : [];
    } catch (error) {
        console.error("Error fetching available logos:", error);
        throw error;
    }
}
    export const insertModelDetails = async (payload: {
        Name: string;
        Display_Name: string;
        Input_Cost: number;
        Output_Cost: number;
        Is_Active: boolean | number;
        Token_Limit_Per_Day: number;
        Model_Provider: string;
        Model_id: string;
        Category: string;
        is_Voice_Enabled: boolean | number;
        voice_input_rate: number;
        voice_output_rate: number;
        }) => {
        const response = await fetch(`${BackendURL}/insert_model_details`, {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });
        
  const data = await response.json();
 
  if (!response.ok) {
    throw new Error(
      data.message || data.error || "Failed to insert model"
    );
  }
  return data;
};
 
 
 
 
export const getModelManagementDetails = async () => {
  const response = await fetch(`${BackendURL}/get_modelmgmt_data`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
 
  const data = await response.json();
 
  if (!response.ok) {
    throw new Error(
      data.message || data.error || "Failed to fetch model details"
    );
  }
  return data;
};
 
export const deleteModelManagementDetails = async (modelId:any) => {
  const response = await fetch(`${BackendURL}/delete_model_details`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      Model_id: modelId,
    }),
  });
 
  const data = await response.json();
 
  if (!response.ok) {
    throw new Error(
      data.message || data.error || "Failed to delete model details"
    );
  }
 
  return data;
};
 
export const tenantOnboarding = async (payload: any) => {
        const response = await fetch(`${BackendURL}/tenant_onboarding`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });
 
    if (!response.ok) {
        throw new Error(`Failed to submit tenant onboarding. Status: ${response.status}`);
    }
 
    return await response.json();
};
 



